export default __webpack_public_path__ + "static/media/Malak_Trabelsi_2_AHV_In_Moms_We_Trust.d5634937.jpg";